import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Grid,
  FormControl,
  useMediaQuery,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { useUser } from "../context/UserContext";
import {
  addSoldItemManually,
  fetchSoldItemById,
  fetchItemsByOrgId,
} from "../services/api";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import SpinnerLoading from "../utility/LoadingIndicator";



const SoldItems = () => {
  const [soldItems, setSoldItems] = useState([]);
  const [aggregatedSoldItems, setAggregatedSoldItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const { user } = useUser();
  const [items, setItems] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg")); // For large devices
  const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
  const [date, setDate] = useState("");
  const [newSoldItem, setNewSoldItem] = useState({
    itemId: "",
    itemName: "",
    sold_stockQuantity: "",
    sold_cost: "",
    quantity_ml: "",
    soldCreatedAt: date,
  });

  const itemInputRef = useRef(null);

  //fetch items by orgId

  const fetchItems = async () => {
    if (!user || !user.orgId) return;

    try {
      const response = await fetchItemsByOrgId(user.orgId);
      console.log(response.data.data);

      if (response && response.status === 200 && Array.isArray(response.data.data)) {
        // Group items by itemName (corrected)
        const groupedItems = response.data.data.reduceRight((acc, item) => {
          const existingItem = acc.find((i) => i.itemName === item.itemName);
          if (existingItem) {
            existingItem.item_stockQuantity += item.item_stockQuantity;
          } else {
            acc.push({ ...item });
          }
          return acc;
        }, []);


        const sortedData = groupedItems.sort((a, b) => a.item_quantity - b.item_quantity);
        setItems(sortedData);
        console.log("Grouped & Sorted Items:", sortedData);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
      setItems([]);
    }
  };




  // fetch sold items by billId
  const fetchSoldItems = async () => {
    try {
      const response = await fetchSoldItemById(user.orgId);
      if (response && response.status === 200) {
        const soldItemsData = response.data.data;
        setSoldItems(soldItemsData);
        console.log("sold Items", soldItemsData);
      }
    } catch (error) {
      console.error("Failed to fetch sold items:", error);
    }
  };
  const fetchSoldItemsForAggregate = async () => {
    try {
      const response = await fetchSoldItemById(user.orgId);

      if (response && response.status === 200) {
        const soldItemsData = response.data.data;

        // Group items by itemName and sum up sold_stockQuantity
        const AggregatedSoldItems = soldItemsData.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.itemName === item.itemName);
          if (existingItem) {
            existingItem.sold_stockQuantity += item.sold_stockQuantity;
          } else {
            acc.push({ ...item });
          }
          return acc;
        }, []);

        setAggregatedSoldItems(AggregatedSoldItems);
        console.log("Aggregated sold items:", AggregatedSoldItems);
      }
    } catch (error) {
      console.error("Failed to fetch sold items:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchItems();
      await fetchSoldItems();

      setLoading(false);
    };
    fetchData();
  }, []);

  const calculateTotalValue = (quantity, price) => {
    return quantity * price; 
  };

  const filteredSoldItems = Array.isArray(soldItems)
    ? soldItems.filter((item) =>
      item.itemName?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleOpen = () => {
    fetchSoldItemsForAggregate();

    setOpen(true);
    setNewSoldItem({
      itemId: "",
      sold_stockQuantity: "",
      sold_cost: "",
      quantity_ml: "",
      soldCreatedAt:date,
    });
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem([]);
    setDate("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewSoldItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  //items sell method
  const handleSellItem = async (e) => {
    // Prevent multiple submissions
    setIsSubmitting(true);

    if (newSoldItem.itemId === "") {
      toast.error("Please fill the all fields!");
      setIsSubmitting(false);
      return;
    }
    if (newSoldItem.soldCreatedAt === "") {
      toast.error("Please select date to sale...!");
      setIsSubmitting(false);
      return;
    }

    const {
      itemId,
      itemName,
      sold_stockQuantity,
      sold_cost,
      quantity_ml,
      soldCreatedAt
    } = newSoldItem;

    // Find the selected item from the items array
    const selectedItem = items.find((item) => item.itemName === itemName);

    // Check if the selected item's stock is sufficient for the requested quantity
    if (
      sold_stockQuantity >
      selectedItem.item_stockQuantity -
      (soldItems.find(
        (soldItem) => soldItem.itemName === selectedItem.itemName
      )?.sold_stockQuantity || 0)
    ) {
      console.log("Insufficient stock validation triggered.");

      // Calculate remaining stock
      const remainingStock =
        selectedItem.item_stockQuantity -
        (aggregatedSoldItems.find(
          (soldItem) => soldItem.itemName === selectedItem.itemName
        )?.sold_stockQuantity || 0);

      // Display warning with remaining stock
      toast.warn(
        `Insufficient stock. Currently available beverages are ${remainingStock > 0 ? remainingStock : 0
        } only!`
      );
      setIsSubmitting(false);
      return;
    }

    // Check if all fields are filled
    if (
      !itemId ||
      !sold_stockQuantity ||
      !sold_cost ||
      !quantity_ml ||
      !soldCreatedAt
    ) {
      toast.error("Please fill in all fields before selling an item.");
      setIsSubmitting(false);
      return;
    }

    const newSoldItemEntry = {
      sold_itemId: `${itemId}-${Date.now()}`,
      itemId,
      itemName,
      sold_stockQuantity: Number(sold_stockQuantity),
      sold_cost: Number(sold_cost),
      soldCreatedBy: user.userId,
      orgId: user.orgId,
      quantity_ml: Number(quantity_ml),
      soldCreatedAt: date
    };

    try {
      const response = await addSoldItemManually(
        newSoldItemEntry.sold_itemId,
        newSoldItemEntry.itemId,
        newSoldItemEntry.itemName,
        newSoldItemEntry.sold_stockQuantity,
        newSoldItemEntry.sold_cost,
        newSoldItemEntry.soldCreatedBy,
        newSoldItemEntry.orgId,
        newSoldItemEntry.quantity_ml,
        newSoldItemEntry.soldCreatedAt,
      );

      if ((response && response.status === 200) || response.status === 201) {
        toast.success("Sold item added successfully.");
        setSoldItems((prevItems) => [...prevItems, newSoldItemEntry]);
        fetchSoldItems();
        fetchSoldItemsForAggregate();
        setSelectedItem([]);


        // Focus back to the Item input field
        if (itemInputRef.current) {
          setTimeout(() => itemInputRef.current.focus(), 100); // Slight delay to ensure UI updates before focusing
        }
      } else if (
        response.status === 400 ||
        response.message === "Insufficient stock quantity. Cannot sell more than available."
      ) {
        toast.error(response.message);
      }

      setNewSoldItem({
        itemId: "",
        sold_stockQuantity: "",
        sold_cost: "",
        quantity_ml: "",
        soldCreatedAt:date
      });
      
    } catch (error) {
      console.error("Failed to add sold item:", error);
      toast.error("Failed to add sold item. Please try again.");
    } finally {
      // Re-enable the button after processing
      setIsSubmitting(false);
    }
  };


  const handleReset = () => {
    setNewSoldItem({
      itemId: "",
      sold_stockQuantity: "",
      sold_cost: "",
      quantity_ml: "",
      soldCreatedAt:"",
    });
    setSelectedItem([]);

  }

  const availableStockRef = useRef(null);

  useEffect(() => {
    if (selectedItem && availableStockRef.current) {
      availableStockRef.current.focus(); // Focus on Available Quantity field
    }
  }, [selectedItem]); // Runs when selectedItem changes

  return (

    <>
      <style>
        {`
          @media (min-width: 1200px) {
              .css-5c1adp-MuiContainer-root {
                  max-width: 100vw !important;
              }
          }
        `}
      </style>

      <Container>
        <ToastContainer />
        <Box sx={{ marginTop: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexDirection={isMobile ? "column" : "row"}
            gap={2}
            sx={{ marginBottom: 1 }}
          >
            <Typography
              sx={{ color: "#024CAA" }}
              variant={isMobile ? "h6" : "h5"}
              gutterBottom
            >
              Sold Beverage Items
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search by item name"
              sx={{
                input: { color: "#071952", padding: "8px" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#071952" },
                  "&:hover fieldset": { borderColor: "#071952" },
                  "&.Mui-focused fieldset": { borderColor: "#3572EF" },
                },
                width: isMobile ? "100%" : "32%",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon style={{ color: "#071952" }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpen}
              sx={{
                marginLeft: { xs: "auto", sm: "0px" },
                marginRight: { xs: "auto", sm: "0px" },
                marginTop: isMobile ? 1 : 0,
                width: { xs: "70%", sm: "auto" },
                textTransform: "none",
              }}
            >
              Sell Item
            </Button>
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: isExtraLargeDevice
                ? 520 // Height for extra-large devices
                : isLargeDevice
                  ? 420 // Height for large devices
                  : 370, // Default height for other devices
              maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
              margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              "&::-webkit-scrollbar": {
                width: "6px",
                height: "6px",
              },
              "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Item Code
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Item Name
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Quantity(ml)
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Sales Quantity
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    MRP
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Sales Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (<TableRow>
                  <TableCell colSpan={7} align="center" sx={{ padding: 0, height: "60px" }}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="100%" // Spinner height inside table
                    >
                      <SpinnerLoading color="primary" />
                    </Box>
                  </TableCell>
                </TableRow>) : filteredSoldItems.length > 0 ? (
                  filteredSoldItems
                    .slice()
                    .reverse()
                    .map((item) => (
                      <TableRow key={item.sold_itemId}>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.itemId}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.itemName}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {`${item.quantity_ml}ml`}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.sold_stockQuantity}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          ₹ {item.sold_cost.toFixed(2)}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          ₹ {calculateTotalValue(
                            item.sold_stockQuantity,
                            item.sold_cost
                          ).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      sx={{ color: "#133E87" }}
                    >
                      No sales items found.
                    </TableCell>
                  </TableRow>
                )}

              </TableBody>
            </Table>
          </TableContainer>

          {/* sold items modal */}

          <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth sx={{ borderRadius: "18px" }}
            PaperProps={{
              sx: {
                width: "450px",
                margin: "auto", // Ensures the dialog stays centered
                borderRadius: "8px"
              },
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent default form submission behavior
                handleSellItem();
              }
            }}
          >
            <DialogTitle color="primary" >Sale Item</DialogTitle>
            <IconButton
              onClick={handleClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent sx={{ paddingBottom: "0px", paddingTop: "0px" }}>
              <Grid item xs={6} sm={4} md={2} sx={{ display: "flex", justifyContent: "end" }}>
                <DatePicker
                  selected={date}
                  onChange={(selectedDate) => {
                    if (selectedDate) {
                      // Ensure time is set to avoid timezone shifts
                      const adjustedDate = new Date(selectedDate);
                      adjustedDate.setHours(12, 0, 0, 0); // Set time to noon to avoid timezone issues

                      setDate(adjustedDate);
                      setNewSoldItem((prevItem) => ({
                        ...prevItem,
                        soldCreatedAt: adjustedDate,
                      }));
                    }
                  }}


                  maxDate={new Date()}
                  dateFormat="dd-MM-yyyy"
                  customInput={
                    <TextField
                      label="Select Date"
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={date ? dayjs(date).format("DD-MM-YYYY") : ""}
                      // required
                      sx={{
                        "& .MuiInputBase-root": { height: "37px", maxWidth: "192px", textAlign: "center" },
                        margin: "5px 0px 15px 0px ",
                      }}
                    />
                  }
                  popperProps={{ positionFixed: true }}
                  wrapperClassName="date-picker-wrapper"
                />
              </Grid>
              <FormControl fullWidth sx={{ marginTop: 1 }}>
                <Autocomplete
                  options={items}
                  size="small"
                  getOptionLabel={(option) => option.itemName || ""}
                  value={
                    items.find((item) => item.itemName === newSoldItem.itemName) || null
                  }
                  onChange={(event, selectedItem) => {
                    if (selectedItem) {
                      setSelectedItem(selectedItem);
                      setNewSoldItem((prevItem) => ({
                        ...prevItem,
                        itemName: selectedItem.itemName,
                        itemId: selectedItem.itemId,
                        sold_cost: selectedItem.item_sellingCost || "",
                        quantity_ml: selectedItem.item_quantity || "",
                        soldCreatedAt:date || "",
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Item"
                      placeholder="Search Item"
                      inputRef={itemInputRef} // Use inputRef here
                    />
                  )}
                />
              </FormControl>
              <TextField
                fullWidth
                margin="normal"
                size="small"
                label={`Available Quantity (${selectedItem.itemName
                  ? selectedItem.item_stockQuantity -
                  (aggregatedSoldItems.find(
                    (soldItem) => soldItem.itemName === selectedItem.itemName
                  )?.sold_stockQuantity || 0)
                  : 0
                  })`}
                type="number"
                name="sold_stockQuantity"
                value={newSoldItem.sold_stockQuantity || ""}
                onChange={(e) =>
                  setNewSoldItem((prevItem) => ({
                    ...prevItem,
                    sold_stockQuantity: e.target.value,
                  }))
                }
                onWheel={(e) => e.target.blur()}
                onKeyDown={(e) =>
                  e.key === "ArrowUp" || e.key === "ArrowDown"
                    ? e.preventDefault()
                    : null
                }
                InputProps={{ inputProps: { min: 0 } }}
                inputRef={availableStockRef} // Set reference here
              />

              <TextField
                fullWidth
                margin="normal"
                label="Cost Price"
                type="number"
                name="sold_cost"
                value={newSoldItem.sold_cost || ""}
                InputProps={{ inputProps: { min: 0 }, readOnly: true }}
                InputLabelProps={{ shrink: true }}
                disabled
                required
                size="small"
              />

              <TextField
                fullWidth
                margin="normal"
                label="Quantity (ml)"
                type="number"
                name="quantity_ml"
                value={newSoldItem.quantity_ml || ""}
                InputProps={{ inputProps: { min: 0 }, readOnly: true }}
                InputLabelProps={{ shrink: true }}
                disabled
                size="small"
              />
            </DialogContent>
            <DialogActions>
              <Button sx={{ background: "#ED3EF7", borderRadius: "5px", marginTop: "5px", marginRight: "10px", marginBottom: "10px", textTransform: "none", color: "white" }} onClick={handleReset} color="primary" variant="contained">
                Reset
              </Button>

              {isSubmitting ? (
                <Button sx={{ backgroundColor: "#006BFF", borderRadius: "5px", marginTop: "5px", marginRight: "15px", marginBottom: "10px", textTransform: "none", color: "white" }} variant="outlined">
                  <CircularProgress size={24} color="#F5F5F5" />
                </Button>
              ) : (
                <Button sx={{ backgroundColor: "#006BFF", borderRadius: "5px", marginTop: "5px", marginRight: "15px", marginBottom: "10px", textTransform: "none", color: "white" }} onClick={handleSellItem} color="primary" variant="outlined">
                  Sell
                </Button>
              )}
            </DialogActions>
          </Dialog>

        </Box>
      </Container>
    </>
  );
};

export default SoldItems;